import type { AlertItem, Locale } from '../types';
import { PanelTitle } from './PanelTitle';
import { AlertCard } from './AlertCard';

export function AlertsPanel(
  title: string,
  subtitle: string,
  items: AlertItem[],
  locale: Locale,
  hasRecs: boolean,
  recHint: string,
): string {
  const rows = items.map((a) => AlertCard(a, locale)).join('');
  return `
  <div class="panel span5">
    ${PanelTitle('alert-triangle', title, 'alerts', hasRecs, recHint)}
    <div class="sub">${subtitle}</div>
    <div class="alerts" role="list">${rows}</div>
  </div>`;
}
